import React from "react";
import classes from "./WalletDropdown.module.scss";
import PaymentIcon from "@material-ui/icons/Payment";
import ReceiptIcon from "@material-ui/icons/Receipt";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPageTitle } from "actions/PageTitle";
import { useTranslation } from "react-i18next";

export default function WalletDropdown({
  toggle,
  setOpen,
  handleToggleDropdown,
}) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  return (
    <div
      className={toggle ? classes.toggleDropdown : classes.toggleDropdownNone}
    >
      <ul className={classes.ulDropdown}>
        <li
          className={
            i18n.language === "en" ? classes.dropdownLtr : classes.dropdownRtl
          }
          onClick={() => {
            setOpen((prevVal) => !prevVal);
            handleToggleDropdown();
          }}
        >
          <span
            className={classes.listItem}
            style={{
              color: "#1d1c22",
              textAlign: i18n.language === "en" && "left",
            }}
          >
            <p>{t("header.charge_account_small")}</p>
            <AttachMoneyIcon style={{ fontSize: "20px", padding: 3 }} />
          </span>
        </li>

        <hr />
        <Link style={{ textDecoration: "none" }} to={"/app/invoice-page"}>
          <li
            className={
              i18n.language === "en" ? classes.dropdownLtr : classes.dropdownRtl
            }
            onClick={() => {
              handleToggleDropdown();
              dispatch(setPageTitle(t("header.invoices")));
            }}
          >
            <span
              className={classes.listItem}
              style={{
                color: "#1d1c22",
              }}
            >
              <p>{t("header.invoices")}</p>
              <ReceiptIcon style={{ fontSize: "20px", padding: 3 }} />
            </span>
          </li>
        </Link>
        <Link style={{ textDecoration: "none" }} to={"/app/transaction-page"}>
          <li
            className={
              i18n.language === "en" ? classes.dropdownLtr : classes.dropdownRtl
            }
            onClick={() => {
              handleToggleDropdown();
              dispatch(setPageTitle(t("header.transactions")));
            }}
          >
            <span className={classes.listItem} style={{ color: "#1d1c22" }}>
              <p>{t("header.transactions")}</p>
              <PaymentIcon style={{ fontSize: "20px", padding: 3 }} />
            </span>
          </li>
        </Link>
      </ul>
    </div>
  );
}
